import React, {useEffect, useMemo, useState} from "react";
import closeIcon from "../../img/closeIcon.svg";
import manDoc from "../../img/manDocumentPage.jpg";
// import radioBtnCheckIcon from "../../img/radioButtonCheckedIcon.svg";
// import radioBtnUnCheckIcon from "../../img/radioButtonUnCheckedIcon.svg";
import addPlusIcon from "../../img/addPlusBlueIcon.svg";
import minusIcon from "../../img/iconMinus.svg";
import rowUpIcon from "../../img/rowUpIcon.svg";
import rowDownIcon from "../../img/rowDownIcon.svg";
import notActiveIconPlus from "../../img/notActiveIconPlus.svg";
import {useFormik} from "formik";
import * as Yup from "yup";
// import CustomSelectIsMulti from "../../utils/CustomSelectIsMulti/CustomSelectIsMulti";
import CustomSelect from "../../utils/CustomSelect/CustomSelect";
import useGetListTemplate from "../../utils/CustomHooks/useGetListTemplate/useGetListTemplate";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import NoOptionsClearValue from "../ReusedComponents/NoOptionsClearValue/NoOptionsClearValue";
import {axiosGetListMan} from "../../Api/ApiMan/axiosGetListMan";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import useGetGoodsEditDoc from "../../utils/CustomHooks/useGetGoodsEditDoc/useGetGoodsEditDoc";

const CreateDocSetManModal = (props) => {

    const {
        closeModal,
        cargoCaseDocument,
        addManCargoCase,
        editDoc,
        selectedCargoCaseMan
    } = props;

    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    // const [toggleTemplateBtn, setToggleTemplateBtn] = useState('2');
    const [activeOpenOptional, setActiveOpenOptional] = useState(false);
    const [isSumBolGrossWeight, setSumBolGrossWeight] = useState(0);
    const [valueLoadingOrder, setValueLoadingOrder] = useState(0);
    const [valueBol, setValueBol] = useState({});
    const [optionDatesBol, setOptionDatesBol] = useState([]);
    const [optionsBols, setOptionsBols] = useState([]);
    const [valueDateBol, setValueDateBol] = useState({});
    const currentCargoCaseMan = useMemo(() => selectedCargoCaseMan,[selectedCargoCaseMan]);
    const {isOptionsTemplate} = useGetListTemplate(auth?.user?.organization, 'MAN');
    const {valueGoodsEditDoc} = useGetGoodsEditDoc(editDoc, optionsBols, currentCargoCaseMan[0]);
    const [valueManList, setValueManList] = useState([]);

    const optionsTemplate = isOptionsTemplate.map(el => ({
        value: el?.id,
        label: el?.fileName
    }))

    const optionsLoadingOrder = cargoCaseDocument[0]?.orders?.map(el => ({
        value: el?.id,
        label: el?.number,
        date: el?.date
    }))

    const filtredBolsUsedInCreatedManifests = (manList, cargoCase) => {
        console.log(manList)
            const findManSelectedCargoCase = [];
                manList.forEach((el) => {
            const findMan = cargoCase[0]?.manifests?.find(item => item.id === el.id)
                if(findMan) {
                    findManSelectedCargoCase.push(el)
                }
        })
        function getNotUsedBols(foundMans, bolsCargoCase) {
            const getGoods = foundMans.map(el => el?.goods).flat()
            const notUsedBols = [];
            bolsCargoCase[0]?.bols?.forEach(el => {
                const findBols = getGoods.find(item => item.bol.id === el.id)
                if(findBols === undefined) {
                    notUsedBols.push(el)
                }
            })
            return notUsedBols;
        }
        return getNotUsedBols(findManSelectedCargoCase, cargoCase)  
    }

    const filtredBolsCurrentManifest = (currentMan, bolsCargoCase) => {
        const getGoods = currentMan.map(el => el?.goods).flat()
        const usedBols = [];
        bolsCargoCase[0]?.bols?.forEach(el => {
            const findBols = getGoods.find(item => item.bol.dateOfLoading === el.dateOfLoading)
            if(findBols) {
                usedBols.push(el)
            }
        })
        return usedBols;
    }

    useEffect(() => {

        let isMount = true;

        if(cargoCaseDocument[0]?.manifests.length === 0) {
   
            const filterBolsStatus = cargoCaseDocument[0]?.bols.filter((el => el.status === 'ISSUED' || el.status === 'DRAFT' || el.status === 'TO_CORRECT'))

            isMount && setOptionDatesBol(filterBolsStatus.map(el => ({
                value: el?.id,
                label: el?.dateOfLoading,
            })))
    
            isMount && setOptionsBols(filterBolsStatus.map(el => ({
                value: el?.id,
                label: el?.bookingRef,
                nameOfGoods: el?.descriptionOfGoods,
                marksLabels: el?.bolRemarks,
                unitsType: el?.grossUnitType,
                grossWeight: el?.grossQuantity
            })))

        } else {
            axiosGetListMan(axiosPrivate, isMount, setValueManList);
        }

        return () => {
            isMount = false;
        }
      
    },[])

    useEffect(() => {

        let isMount = true;

        if(valueManList && editDoc === false) {
            const onGetNotUsedBols = filtredBolsUsedInCreatedManifests(valueManList, cargoCaseDocument);

            const filterBolsStatus = onGetNotUsedBols.filter((el => el.status === 'ISSUED' || el.status === 'DRAFT' || el.status === 'TO_CORRECT'))
            
            isMount && setOptionDatesBol(filterBolsStatus.map(el => ({
                value: el?.id,
                label: el?.dateOfLoading,
            })))
    
            isMount && setOptionsBols(filterBolsStatus.map(el => ({
                value: el?.id,
                label: el?.bookingRef,
                nameOfGoods: el?.descriptionOfGoods,
                marksLabels: el?.bolRemarks,
                unitsType: el?.grossUnitType,
                grossWeight: el?.grossQuantity,
                dateOfLoading: el?.dateOfLoading
            })))

        } else if(valueManList && editDoc === true) {

            const findBolsSelectedMan = filtredBolsCurrentManifest(currentCargoCaseMan, cargoCaseDocument);
            const filterBolsStatus = findBolsSelectedMan.filter((el => el.status === 'ISSUED' || el.status === 'DRAFT' || el.status === 'TO_CORRECT'))
            
            isMount && setOptionDatesBol(filterBolsStatus.map(el => ({
                value: el?.id,
                label: el?.dateOfLoading,
            })))
    
            isMount && setOptionsBols(filterBolsStatus.map(el => ({
                value: el?.id,
                label: el?.bookingRef,
                nameOfGoods: el?.descriptionOfGoods,
                marksLabels: el?.bolRemarks,
                unitsType: el?.grossUnitType,
                grossWeight: el?.grossQuantity,
                dateOfLoading: el?.dateOfLoading
            })))
            setValueDateBol(filterBolsStatus[0]?.dateOfLoading)
        }

        return () => {
            isMount = false;
        }

    },[valueManList, editDoc])

    function idGenerate(arr) {
        if (arr.length < 1) {
            return 1;
        } else {
            const allIdArray = arr.map((arr) => {
                return arr.id;
            });
            return Math.max(...allIdArray) + 1;
        }
    }

    const onHandleClearValue = () => {
        formik.setFieldValue('template_id', '')
    }

    const onClearTemplate = () => {
        return (
            <NoOptionsClearValue
                onHandleClearValue={() => onHandleClearValue()}
            />
        )
    }

    const formik = useFormik({
        initialValues: {
            dateOfLoading: editDoc === true ? currentCargoCaseMan[0]?.goods[0]?.bol?.dateOfLoading : valueDateBol?.label,
            shipper: cargoCaseDocument[0]?.shipper,
            portOfLoading: cargoCaseDocument[0]?.portOfLoading,
            portOfDischarge: cargoCaseDocument[0]?.bols[0]?.portOfDischarge,
            vessel: cargoCaseDocument[0]?.vessel,
            captain_id: cargoCaseDocument[0]?.captain?.id,
            consignee: cargoCaseDocument[0]?.consignee,
            cargoCaseId: cargoCaseDocument[0]?.id,
            number: editDoc === true ? currentCargoCaseMan[0]?.number : "",
            shipowner_id: cargoCaseDocument[0]?.shipowner.id,
            shippersAgent: editDoc === true ? currentCargoCaseMan[0]?.shippersAgent : "",
            finalDestination: cargoCaseDocument[0]?.bols[0]?.portOfDischarge.name,
            kindOfGood: cargoCaseDocument[0]?.numberCertOfOrigin,
            freight: editDoc === true ? currentCargoCaseMan[0]?.goods[0]?.bol?.notify : '',
            notify: editDoc === true ? currentCargoCaseMan[0]?.notify : "",
            goods: editDoc === true ? valueGoodsEditDoc : [],
            template_id: editDoc === true && currentCargoCaseMan[0]?.template !== undefined ? currentCargoCaseMan[0]?.template?.id : '',
            vesselFlag_id: cargoCaseDocument[0]?.vesselFlag?.id,
            validationOrders: false
        },
        validationSchema: Yup.object({
            dateOfLoading: Yup.string()
                .required('Required field!'),
            number: Yup.string()
                .min(1, 'Min 1 symbol')
                .matches(/(?:\s|^)[\p{L}\p{M}0-9\-._]+(?:\s|$)/u, 'Is not in correct format!')
                .required('Required field!'),
            shippersAgent: Yup.string()
                .required('Required field!'),
            goods: Yup.array()
                .min(1, 'Min one bill of lading must be selected!')
                .required('Required field!'),
            kindOfGood: Yup.string()
                .required('Required field!'),
            // freight: Yup.string()
            //     .required('Required field!'),
            notify: Yup.string()
                .matches(/(?:\s|^)[\p{L}\p{M}0-9\-._]+(?:\s|$)/u, 'Is not in correct format!'),
            validationOrders: Yup.boolean()
                .oneOf([true], "Loading order and bol must be selected!")
                .required('Required field!'),
        }),
        onSubmit: values => addManCargoCase(values, cargoCaseDocument[0]?.id, currentCargoCaseMan[0]?.id)
    })

    const onFilterBolsOnDate = (dateBol) => {

        if(valueDateBol.label === dateBol) {
            return
        } 

        formik.setFieldValue('goods', [])

        const onGetNotUsedBols = filtredBolsUsedInCreatedManifests(valueManList, cargoCaseDocument);
     
        const filterBolsStatus = onGetNotUsedBols.filter((el => el.status === 'ISSUED' || el.status === 'DRAFT' || el.status === 'TO_CORRECT'))
        
        const selectedBol = filterBolsStatus.map(el => ({
            value: el?.id,
            label: el?.bookingRef,
            nameOfGoods: el?.descriptionOfGoods,
            marksLabels: el?.bolRemarks,
            unitsType: el?.grossUnitType,
            grossWeight: el?.grossQuantity,
            dateOfLoading: el?.dateOfLoading
        }))

        const findCurrentManBols = [];
        selectedBol.forEach(el => {
            if(el.dateOfLoading === dateBol) {
                findCurrentManBols.push(el)
            }
        })
        setOptionsBols(findCurrentManBols);
    }

    const onChangeDatesBol = (optionsDateBol) => {
        optionsDateBol.value ? setValueDateBol(optionsDateBol) : setValueDateBol({});
        onFilterBolsOnDate(optionsDateBol.label)
        formik.setFieldValue('dateOfLoading', optionsDateBol.label)
      };

    const onChangeLoadingOrder = (optionsOrders, bolId) => {
        const findEditBol = formik.values.goods.find(el => el.id === bolId)
        const changedBol = {...findEditBol, loading_order_id: optionsOrders.value, loading_order_date: optionsOrders.date}
        const updatedBolTable = formik.values.goods.map(el => el.id === changedBol.id ? changedBol : el)
        formik.setFieldValue('goods', updatedBolTable)
      };

    const onChangeBol = (optionsBol, bolId) => {
        const findEditBol = formik.values.goods.find(el => el.id === bolId)
        const changedBol = {...findEditBol, bol_id: optionsBol.value, grossWeight: optionsBol.grossWeight, marksLabels: optionsBol.marksLabels, nameOfGoods: optionsBol.nameOfGoods, unitsType: optionsBol.unitsType}
        const updatedBolTable = formik.values.goods.map(el => el.id === changedBol.id ? changedBol : el)
        formik.setFieldValue('goods', updatedBolTable.sort((a, b) => a.bol_id - b.bol_id))
      };  
      
    const onHandlerAddGoods = () => {
        const itemGoods = {
            id: idGenerate(formik.values.goods),
            bol_id: null,
            loading_order_id: null,
            nameOfGoods: "",
            marksLabels: "",
            unitsType: "KGS",
            grossWeight: null
        }
        formik.setFieldValue('goods', [...formik.values.goods, itemGoods])
    }

    const onHandlerDeleteGoods = (goodId) => {
        const filterDeleteGoods = formik.values.goods.filter(el => el.id !== goodId)
        formik.setFieldValue('goods', filterDeleteGoods)
    }

    useEffect(() => {
        if(editDoc === true && optionsBols.length !== 0) {
            formik.setFieldValue('goods', valueGoodsEditDoc)
        }
    },[valueGoodsEditDoc])

    useEffect(() => {
        if (formik?.values?.goods?.length !== 0) {
            const modifyBillOfLandingTable = formik?.values?.goods?.map(el => el)
            const resultGrossWeightBols = modifyBillOfLandingTable.sort((a, b) => a.bol_id - b.bol_id).reduce((a, c) => {
                if(Object.values(a).map(e => e.bol_id).indexOf(c.bol_id) === -1) a.push(c);
                return a;
            }, [])
            setSumBolGrossWeight(Number(resultGrossWeightBols?.map(el => el?.grossWeight).reduce((acc, el) => acc + el)))
        } else {
            setSumBolGrossWeight(null);
        }
    }, [formik.values.goods])

    useEffect(() => {
        if(formik.values.goods.length !== 0) {
            const findLoadingOrderElem = formik.values.goods.some(el => el.loading_order_id === null);
            const findBolElem = formik.values.goods.some(el => el.bol_id === null);
            if (findLoadingOrderElem === false && findBolElem === false) {
                formik.setFieldValue('validationOrders', true)    
            } else{
                formik.setFieldValue('validationOrders', false)
            }   
        } else {
            formik.setFieldValue('validationOrders', false)
        }
    },[formik.values.goods])

    function onEditModeLoadingOrder(loadingOrderId, optionsOrder) {
        const findItem = optionsOrder.find(el => el?.value === loadingOrderId)
        return findItem?.label
    }

    function deleteDublicateGrossWeightBols(arrayBols, currentGrossWeight) {
        const currentValue = arrayBols.indexOf(currentGrossWeight);
        const lastValue = arrayBols.find((el, index) => index === currentValue - 1);
        if(currentGrossWeight?.bol_id === lastValue?.bol_id) {
            return null
        } else {
            return currentGrossWeight.grossWeight
        }
    }

    return (
            <div className="create-doc-set-man-modal__container">
                <form onSubmit={formik.handleSubmit} className="create-doc-set-man-modal">
                    <div className="create-doc-set-man-modal__title">
                        <h3>MAN</h3>
                        <img onClick={closeModal} src={closeIcon} alt={'иконка крестик'}/>
                    </div>
                    <div className="create-doc-set-man-modal-main-block">
                        <div className="create-doc-set-man-modal__document-image-page">
                            <img className="create-doc-set-man-modal__document-img" src={manDoc} alt={'изображение документа'}/>
                        </div>
                        <div className="create-doc-set-man-modal__templates">
                            <div className="create-doc-set-man-modal__templates-radio-buttons">
                                <div className="create-doc-set-loading-order-modal__three-inputs-item">
                                    <label htmlFor="template_id">Select template</label>
                                    <CustomSelect
                                        options={optionsTemplate}
                                        value={formik.values.template_id}
                                        onChange={value => formik.setFieldValue('template_id', value.value)}
                                        noOptionsMessage={() => onClearTemplate(formik.values.template_id)}
                                    />
                                </div>
                                {/*<div className="create-doc-set-man-modal__templates-btn">*/}
                                {/*    <img onClick={() => setToggleTemplateBtn('1')} className={toggleTemplateBtn === '1' ? "create-doc-set-man-modal__templates-btn-icon active" : "create-doc-set-man-modal__templates-btn-icon"} src={toggleTemplateBtn === '1' ? radioBtnCheckIcon : radioBtnUnCheckIcon} alt={'радио-кнопка'}/>*/}
                                {/*    <p className="create-doc-set-man-modal__templates-label">Template 1</p>*/}
                                {/*</div>*/}
                                {/*<div className="create-doc-set-man-modal__templates-btn">*/}
                                {/*    <img onClick={() => setToggleTemplateBtn('2')}  className={toggleTemplateBtn === '2' ? "create-doc-set-man-modal__templates-btn-icon active" : "create-doc-set-man-modal__templates-btn-icon"} src={toggleTemplateBtn === '2' ? radioBtnCheckIcon : radioBtnUnCheckIcon} alt={'радио-кнопка'}/>*/}
                                {/*    <p className="create-doc-set-man-modal__templates-label">Template 2</p>*/}
                                {/*</div>*/}
                            </div>
                            <div className="create-doc-set-man-modal__templates-group-inputs">
                                <div className="create-doc-set-man-modal__templates-input">
                                    <label>MAN number</label>
                                    <input className="create-doc-set-man-modal__templates-input-text"
                                        type={"text"}
                                        name={'number'}
                                        defaultValue={editDoc === true ? currentCargoCaseMan[0]?.number : formik.values.name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.errors.number && formik.touched.number ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.number}</p> : null}
                                </div>
                                <div className={editDoc === true ? "create-doc-set-man-modal__templates-input-disabled" : "create-doc-set-man-modal__templates-input"}>
                                    <label htmlFor="dateOfLoading">Select bill of lading date</label>
                                    <CustomSelect
                                        options={optionDatesBol}
                                        value={valueDateBol}
                                        onChange={onChangeDatesBol}
                                        placeholder={editDoc === true ? currentCargoCaseMan[0]?.goods[0]?.bol?.dateOfLoading : "Select bill of lading date"}
                                    />
                                    {formik.errors.dateOfLoading && formik.touched.dateOfLoading && <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.dateOfLoading}</p>}
                                </div>
                            </div>
                            <div className="create-doc-set-man-modal__table-block">
                                <table className="create-doc-set-man-modal__table-grid">
                                    <tbody>
                                    <tr className="create-doc-set-man-modal__table-grid-header">
                                        <th className="create-doc-set-man-modal__table-grid-header-col1">
                                            B/L №
                                        </th>
                                        <th className="create-doc-set-man-modal__table-grid-header-col2">
                                            Loading Order №
                                        </th>
                                        <th className="create-doc-set-man-modal__table-grid-header-col3">
                                            Loading Order Date
                                        </th>
                                        <th className="create-doc-set-man-modal__table-grid-header-col4">
                                            Gross weight
                                        </th>
                                    </tr>
                                    {formik.values.goods.map((el) => {
                                        return (
                                            <tr key={el.id} className="create-doc-set-man-modal__table-grid-row">
                                                <td className="create-doc-set-man-modal__table-grid-row1">
                                                    <CustomSelect
                                                        options={optionsBols}
                                                        defaultValue={valueBol}
                                                        placeholder={editDoc === true ? el.label : 'Select bill of lading'}
                                                        onChange={value => onChangeBol(value, el.id)}
                                                    />
                                                </td>
                                                <td className="create-doc-set-man-modal__table-grid-row2">
                                                    <CustomSelect
                                                        options={optionsLoadingOrder}
                                                        value={valueLoadingOrder}
                                                        placeholder={editDoc === true ? onEditModeLoadingOrder(el.loading_order_id, optionsLoadingOrder) : 'Select loading order'}
                                                        onChange={value => onChangeLoadingOrder(value, el.id)}
                                                    />
                                                </td>
                                                <td className="create-doc-set-man-modal__table-grid-row3">{el?.loading_order_date}</td>
                                                <td className="create-doc-set-man-modal__table-grid-row4">{deleteDublicateGrossWeightBols(formik.values.goods, el)}</td>
                                                {!el.edit && <td onClick={() => onHandlerDeleteGoods(el.id)} className="create-doc-set-man-modal__table-grid-del-bol">
                                                    <img className="create-doc-set-man-modal__table-grid-add-bol-icon" src={minusIcon} alt={'icon'}/>
                                                </td>}  
                                            </tr>
                                        )
                                    })}
                                     <tr className="create-doc-set-man-modal__table-grid-row">
                                        <td className="create-doc-set-man-modal__table-grid-footer-col1">
                                            <div onClick={onHandlerAddGoods} className={Object.keys(valueDateBol).length !== 0 ? "create-doc-set-man-modal__table-grid-add-bol" : "create-doc-set-man-modal__table-grid-add-bol table-grid-add-bol-not-active"}>
                                                <img src={Object.keys(valueDateBol).length !== 0 ? addPlusIcon : notActiveIconPlus} alt={'icon'}/>
                                                <p className={Object.keys(valueDateBol).length !== 0 ? "create-doc-set-man-modal__table-grid-add-bol-text" : "create-doc-set-man-modal__table-grid-add-bol-text__color-gray"}>
                                                    Add bol
                                                </p>
                                            </div>           
                                        </td>
                                        <td className="create-doc-set-man-modal__table-grid-footer-col2"></td>
                                        <td className="create-doc-set-man-modal__table-grid-footer-col3"></td>
                                        <td className="create-doc-set-man-modal__table-grid-footer-col4"></td>                                               
                                    </tr>
                                    <tr className="create-doc-set-man-modal__table-grid-footer">
                                        <td className="create-doc-set-man-modal__table-grid-footer-col1"></td>
                                        <td className="create-doc-set-man-modal__table-grid-footer-col2"></td>
                                        <td className="create-doc-set-man-modal__table-grid-footer-col3">Total</td>
                                        <td className="create-doc-set-man-modal__table-grid-footer-col4">{isSumBolGrossWeight}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                {formik.errors.validationOrders && formik.touched.validationOrders ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.validationOrders}</p> : null}
                            </div>
                            <div className="create-doc-set-man-modal__templates-one">
                                <label>Vessel</label>
                                <input className="create-doc-set-man-modal__templates-one-input"
                                    type={'text'}
                                    disabled={true}
                                    defaultValue={formik.values.vessel.name}
                                />
                            </div>
                            <div className="create-doc-set-man-modal__templates-one">
                                <label>Flag</label>
                                <input className="create-doc-set-man-modal__templates-one-input"
                                    type={'text'}
                                    disabled={true}
                                    defaultValue={formik.values.vessel.country.name}
                                />
                            </div>
                            <div className="create-doc-set-man-modal__templates-one">
                                <label>Shipowner</label>
                                <input className="create-doc-set-man-modal__templates-one-input"
                                    type={'text'}
                                    disabled={true}
                                    defaultValue={cargoCaseDocument[0]?.shipowner.name}
                                />
                            </div>
                            <div className="create-doc-set-man-modal__templates-group-inputs">
                                <div className="create-doc-set-man-modal__templates-input">
                                    <label>Port of Loading</label>
                                    <input className="create-doc-set-man-modal__templates-input-text"
                                        type={'text'}
                                        disabled={true}
                                        defaultValue={formik.values.portOfLoading?.name}
                                    />
                                </div>
                                <div className="create-doc-set-man-modal__templates-input">
                                    <label>Port of Discharge</label>
                                    <input className="create-doc-set-man-modal__templates-input-text"
                                        type={'text'}
                                        disabled={true}
                                        defaultValue={formik.values.portOfDischarge?.name}
                                    />
                                </div>
                            </div>
                            <div className="create-doc-set-man-modal__templates-one">
                                <label>Final Destination</label>
                                <input className="create-doc-set-man-modal__templates-one-input"
                                        type={'text'}
                                        disabled={true}
                                        defaultValue={formik.values.portOfDischarge?.name}
                                />
                            </div>
                            <div className="create-doc-set-man-modal__templates-one">
                                <label>Bill of Lading date</label>
                                <input className="create-doc-set-man-modal__templates-one-input"
                                        type={"text"}
                                        disabled={true}
                                        defaultValue={editDoc === true ? currentCargoCaseMan[0]?.goods[0]?.bol?.dateOfLoading : formik.values.dateOfLoading}
                                        onChange={formik.handleChange}
                                />
                            </div>
                            <div className="create-doc-set-man-modal__templates-one">
                                <label>Shipper’s Agent</label>
                                <input className="create-doc-set-man-modal__templates-one-input"
                                        type={"text"}
                                        name={'shippersAgent'}
                                        defaultValue={editDoc === true ? currentCargoCaseMan[0]?.shippersAgent : formik.values.name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                />
                                {formik.errors.shippersAgent && formik.touched.shippersAgent ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.shippersAgent}</p> : null}
                            </div>
                            <div className="create-doc-set-man-modal__templates-one">
                                <label>Captain’s name</label>
                                <input className="create-doc-set-man-modal__templates-one-input"
                                        type={'text'}
                                        disabled={true}
                                        defaultValue={cargoCaseDocument[0]?.captain?.firstName + " " + cargoCaseDocument[0]?.captain?.lastName}
                                />
                            </div>
                            <div className="create-doc-set-man-modal__templates-one">
                                <label>Description of Goods</label>
                                <input className="create-doc-set-man-modal__templates-one-input"
                                        type={'text'}
                                        name={'kindOfGood'}
                                        defaultValue={formik.values.kindOfGood}
                                        disabled={true}
                                />
                                {formik.errors.kindOfGood && formik.touched.kindOfGood ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.kindOfGood}</p> : null}
                            </div>
                            <div className="create-doc-set-man-modal__templates-group-inputs">
                                <div className="create-doc-set-man-modal__templates-input">
                                    <label>Shipper</label>
                                    <input className="create-doc-set-man-modal__templates-input-text"
                                        type={'text'}
                                        disabled={true}
                                        defaultValue={formik.values.shipper.name}
                                    />
                                </div>
                                <div className="create-doc-set-man-modal__templates-input">
                                    <label>Consignee</label>
                                    <input className="create-doc-set-man-modal__templates-input-text"
                                        type={"text"}
                                        disabled={true}
                                        defaultValue={formik.values.consignee}
                                    />
                                </div>
                            </div>
                            <div className="create-doc-set-man-modal__templates-one">
                                <label>Freight</label>
                                <input className="create-doc-set-man-modal__templates-one-input"
                                        // type={'text'}
                                        // name={'freight'}
                                        // defaultValue={editDoc === true ? currentCargoCaseMan[0]?.freight : formik.values.name}
                                        // onChange={formik.handleChange}
                                        // onBlur={formik.handleBlur}
                                        type={'text'}
                                        disabled={true}
                                        defaultValue={editDoc === true ? currentCargoCaseMan[0]?.goods[0]?.bol?.notify : formik.values.freight}
                                        onChange={formik.handleChange}
            
                                />
                                {/* {formik.errors.freight && formik.touched.freight ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.freight}</p> : null} */}
                            </div>
                            <div className="create-doc-set-bol-modal__optional">
                                <div className="create-doc-set-bol-modal__optional-open-row">
                                    <p>Optional</p>
                                    <img onClick={() => setActiveOpenOptional(!activeOpenOptional)}  src={activeOpenOptional ? rowUpIcon : rowDownIcon} alt={'иконка стрелочка'}/>
                                </div>
                                <div className={activeOpenOptional ? "create-doc-set-bol-modal__optional-content" : "create-doc-set-bol-modal__optional-content hide"}>
                                    <div className="create-doc-set-bol-modal__optional-content-input">
                                        <label>Notify party</label>
                                        <textarea className="create-doc-set-bol-modal__optional-content-text-area"
                                            placeholder={'text'}
                                            name={'notify'}
                                            defaultValue={editDoc === true ? currentCargoCaseMan[0]?.notify : formik.values.name}
                                            onChange={formik.handleChange}
                                        />
                                        {formik.errors.notify && formik.touched.notify ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.notify}</p> : null}
                                    </div>
                                </div>
                                {/*<div className="create-doc-set-bol-modal__optional-content-input">*/}
                                {/*    <div className="create-doc-set-bol-modal-add-new-field__btn-add-new">*/}
                                {/*        <img src={addPlusIcon} alt={'иконка плюс'} />*/}
                                {/*        <p>Add new field</p>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                    <div className="create-doc-set-bol-modal__buttons">
                        <button onClick={closeModal} className="create-doc-set-bol-modal__buttons-cancel">Cancel</button>
                        <button type={"submit"} className="create-doc-set-bol-modal__buttons-save">Save</button>
                    </div>
                </form>
            </div>
    )
}
export default CreateDocSetManModal;